exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wizard-step-header[data-v-52bc4c7d] {\n  height: 60px;\n  display: flex;\n  align-items: center;\n  border-bottom: 1px solid var(--color11);\n  padding: 0 30px;\n  justify-content: space-between;\n}\n.wizard-step-header-title[data-v-52bc4c7d] {\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 19px;\n  color: var(--color9);\n  display: flex;\n  align-items: center;\n}\n.select-marketing-list[data-v-52bc4c7d] {\n  padding: 0;\n  margin: 0;\n  height: 100%;\n}\n", ""]);

// exports
